// Validates that a string is a well-formed URL using the http(s) scheme.
// Stricter than isValidUrl, which accepts any scheme (mailto:, ftp:, etc.).
export default function isValidHttpUrl(url) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch (e) {
    return false;
  }
  return parsed.protocol === "http:" || parsed.protocol === "https:";
}
